import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import NewsListComponent from './NewsListComponent';
import BottomSide from '../components/BottomSide';
import { Helmet } from 'react-helmet';
import CenteredCircularProgress from '../../components/common/CenteredCircularProgress';


class NewsPage extends Component {

    state = {
        currentPage: 1,
        itemsPerPage: 10, // Adjust the number of news items per page as needed

    };

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    };

    componentDidMount() {
        const { match } = this.props;
        const { pageNumber } = match.params;
        if (pageNumber) {
            this.setState({ currentPage: parseInt(pageNumber, 10) });
        }
    }

    render() {
        const currentUrl = window.location.href;

        const { news } = this.props;
        const { currentPage, itemsPerPage } = this.state;

        // Check if news is undefined
        if (!news) {
            return <CenteredCircularProgress />;
        }

        // Calculate pagination values
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentNews = news.slice(indexOfFirstItem, indexOfLastItem);

        // Render pagination items
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(news.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        return (
            <div>

                <Helmet>
                    <title>News - Bright Youth Community</title>
                    <meta name="description" content="Find the latest news and updates on our organization's events and projects here. Stay informed about developments and join us." />
                    <link rel="canonical" href={currentUrl} />

                    <meta property="og:title" content="News - Bright Youth Community" />
                    <meta property="og:description" content="Find the latest news and updates on our organization's events and projects here. Stay informed about developments and join us." />
                    <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                    <meta property="og:url" content={currentUrl} />
                    <meta property="og:type" content="website" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="News - Bright Youth Community" />
                    <meta name="twitter:description" content="Find the latest news and updates on our organization's events and projects here. Stay informed about developments and join us." />
                    <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                </Helmet>

                <Container className="mt-4">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>News</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>

                <Container className="mt-4">
                    <Row>
                        <Col xs={12}>
                            <h2>News</h2>
                        </Col>
                    </Row>

                </Container>

                <NewsListComponent news={currentNews} />

                {/* Pagination controls */}
                <Container className="mt-4">
                    <Row>
                        <Col xs={8}>
                            <nav aria-label="...">
                                <ul className="pagination">
                                    {/* Previous button */}
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <Link to={`/news/page/${currentPage - 1}`} className="page-link" onClick={() => this.handlePageChange(currentPage - 1)}>Previous</Link>
                                    </li>

                                    {/* Page numbers */}
                                    {pageNumbers.map((number) => (
                                        <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                                            <Link to={`/news/page/${number}`} className="page-link" onClick={() => this.handlePageChange(number)}>
                                                {number}
                                                {number === currentPage && <span className="sr-only"></span>}
                                            </Link>
                                        </li>
                                    ))}

                                    {/* Next button */}
                                    <li className={`page-item ${currentPage === Math.ceil(news.length / itemsPerPage) ? 'disabled' : ''}`}>
                                        <Link to={`/news/page/${currentPage + 1}`} className="page-link" onClick={() => this.handlePageChange(currentPage + 1)}>Next</Link>
                                    </li>
                                </ul>
                            </nav>
                        </Col>
                        <Col xs={4} className="text-end">
                            <p>Page {currentPage} of {Math.ceil(news.length / itemsPerPage)}</p>
                        </Col>
                    </Row>
                </Container>
                <div>
                    <BottomSide />
                </div>


            </div >

        )
    }
}



const mapStateToProps = (state) => {
    return {
        news: state.firestore.ordered.news,
        //currentPage: state.props.match.params.pageNumber
    }
}


export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'news', orderBy: ['created', 'desc'] },
    ])
)(NewsPage)